import { render, staticRenderFns } from "./addmobileLoginParams.vue?vue&type=template&id=36f95084&"
import script from "./addmobileLoginParams.vue?vue&type=script&lang=js&"
export * from "./addmobileLoginParams.vue?vue&type=script&lang=js&"
import style0 from "./addmobileLoginParams.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f95084')) {
      api.createRecord('36f95084', component.options)
    } else {
      api.reload('36f95084', component.options)
    }
    module.hot.accept("./addmobileLoginParams.vue?vue&type=template&id=36f95084&", function () {
      api.rerender('36f95084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginDisposition/components/addmobileLoginParams.vue"
export default component.exports